


















































































































































import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import { runSettingTableColumns } from '../config/colums'
import {
  getRunSettingList,
  addKeywords,
  changeKeywordsStatus,
  deleteRSKeywords,
  editKeywordsStatus,
  getPushStatus
} from '../../../service/search'

@Component
export default class RunSetting extends Vue {
  public searchStatus: any = '-1'
  public key_word: string = '' // 搜索关键词
  public statusArr: any = [] // 状态数组

  public url: string = '' // 设置弹框内关键词URL
  public key_words: any = [''] // 设置弹框内关键词数组

  public editId: string = '' // 修改弹框内关键词id
  public editUrl: string = '' // 修改弹框内关键词URL
  public editKeyWord: string = '' // 修改弹框内关键词

  public showRunSettingModal: boolean = false //设置弹窗
  public showEditModal: boolean = false // 编辑弹窗
  public showMinus: boolean = true // 是否显示减号

  public pagination = {
    current: 1,
    pageSize: 20,
    total: 0,
    showTotal: (total) => `共${total}条`
  }

  public runSettingTableColumns: any[] = runSettingTableColumns
  public dataSource: any[] = []

  addKeyword() {
    this.showMinus = true
    if (this.key_words.length < 10) {
      this.key_words.push('')
    }
  }
  reduceKeyword(index) {
    this.key_words.splice(index, 1)

    if (this.key_words.length == 1) {
      this.showMinus = false
    }
  }
  //切换页
  changePage(pagination) {
    this.pagination.current = pagination.current
    this.getRunSettingList(pagination.current)
  }
  // 搜索列表
  async getRunSettingList(page) {
    const options = {
      key_word: this.key_word,
      status: this.searchStatus * 1,
      page,
      page_size: this.pagination.pageSize
    }
    const { list, total } = await getRunSettingList(options)
    this.dataSource = list
    this.pagination.total = total
    this.pagination.current = page
  }
  // 显示弹框
  showRunSetting() {
    this.url = ''
    this.key_words = ['']
    this.showRunSettingModal = true
  }
  // 确定添加关键字
  async handleModalOk() {
    const options = {
      key_words: this.key_words,
      url: this.url
    }
    const { success, msg } = await addKeywords(options)
    if (success) {
      this.$message.success(msg)
      const pagination = {
        current: 1
      }
      this.changePage(pagination)
      this.showRunSettingModal = false
    }
  }
  handleModalCancel() {
    this.showRunSettingModal = false
  }

  //编辑
  handleEditItem(record) {
    this.editId = ''
    this.editUrl = ''
    this.editKeyWord = ''

    this.showEditModal = true
    this.editId = record.id
    this.editKeyWord = record.key_word
    this.editUrl = record.url
  }
  async handleEditModalOk() {
    const options = {
      id: this.editId,
      key_word: this.editKeyWord,
      url: this.editUrl
    }
    const { success, msg } = await editKeywordsStatus(options)
    if (success) {
      this.$message.success(msg)
      const pagination = {
        current: 1
      }
      this.changePage(pagination)
    }
    this.showEditModal = false
  }
  handleEditModalCancel() {
    this.showEditModal = false
  }

  // 状态修改
  async handleChangeStatus(record: any, searchStatus) {
    const options = {
      id: record.id,
      status: searchStatus
    }
    const { success, msg: message } = await changeKeywordsStatus(options)
    if (success) {
      this.$message.success(message)
      this.getRunSettingList(this.pagination.current)
    } else {
      this.$message.error(message)
    }
  }
  // 确定删除
  async handleDeleteModalOk(record) {
    const options = {
      id: record.id
    }
    const { success, msg: message } = await deleteRSKeywords(options)
    if (success) {
      this.$message.success(message)
      const newData = [...this.dataSource]
      newData.splice(record.key, 1)
      this.dataSource = newData

      let page = 0
      if (newData.length) {
        page = this.pagination.current
      } else {
        page = this.pagination.current === 1 ? 1 : this.pagination.current - 1
      }
      this.getRunSettingList(page)
    } else {
      this.$message.error(message)
    }
  }
  // 获取状态
  async getPushStatus() {
    const { success, data } = await getPushStatus()
    if (success) {
      this.statusArr = data
    }
  }
  mounted() {
    this.getPushStatus()
    this.getRunSettingList(1)
  }
}
